import React from 'react';
import FastImage from 'react-native-fast-image';
import DurationOrange from '../../../assets/images/duration-orange.png';
import DurationGrey from '../../../assets/images/duration-grey.png';
import DurationWhite from '../../../assets/images/duration-white.png';
import DurationBlack from '../../../assets/images/duration-black.png';

import Theme from '../../../theme';

export const DurationIcon = ({
  color = Theme.WHITE,
  width,
  height,
}) => {
  const colourIcons = {
    [Theme.PRIMARY]: DurationOrange,
    [Theme.GREY]: DurationGrey,
    [Theme.WHITE]: DurationWhite,
    [Theme.BLACK]: DurationBlack,
  };
  return (
    <FastImage
      resizeMode='contain'
      style={{
        width,
        height,
      }}
      tintColor={color}
      source={colourIcons[color]}
    />
  );
}
